import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { OrdersInterface } from "src/utils/interfaces/interfaces";
import { OrdersApi } from "src/services/orders/orders";

interface OrdersStateInterface {
  orders: OrdersInterface;
  isLoading: boolean;
}
const initialState: OrdersStateInterface = {
  orders: [],
  isLoading: false,
};

export const OrdersSlice = createSlice({
  name: "Orders",
  initialState,
  reducers: {
    getOrdersSuccess: (state: OrdersStateInterface, { payload }) => {
      state.orders = payload;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchOrders.fulfilled,
      (state: OrdersStateInterface, action) => {
        getOrdersSuccess(action.payload)
      }
    );
  },
});

export const fetchOrders = createAsyncThunk(
  "Orders/fetchOrders",
  async (thunkAPI) => {
    const response = await OrdersApi.useGetOrdersQuery({});
    return response;
  }
);

export const { getOrdersSuccess } = OrdersSlice.actions;

export default OrdersSlice.reducer;
